import React, { useState } from 'react';
import logo_close from '../assets/close-check.png';
import '../styles/Partage.css';

function Partage({p_link,p_idList=null}) {

    const [isformPartage, setisformPartage] = useState(false)
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(p_link);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Réinitialise après 2s
        } catch (err) {
          console.error("Erreur de copie :", err);
        }
      };

    return isformPartage ? (
      <div className="ui-overlay">
            <div className="ui-modal">
            <img src={logo_close} alt="Fermer" onClick={() => setisformPartage(false)} className='kdo-logoclose'/>
                <div>
                  {!p_idList ? (
                    <>
                    <p>Pour partager toutes vos listes, il vous suffit d'envoyer le lien suivant.</p>
                    <p>Si vous ne souhaitez partager qu'une seule de vos listes rendez vous sur le bouton partage en face de la liste concernée.</p>
                    <p>Les utilisateurs pourront simplement consulter vos listes, sans pouvoir les modifier. Il pourront également marquer les objets comme réservés.</p>
                    </>
                  ) : (
                    <>
                    <p>Pour partager vos listes, il vous suffit d'envoyer le lien suivant.</p>
                    <p>Les utilisateurs pourront simplement consulter votre liste, sans pouvoir la modifier. Il pourront également marquer les objets comme réservés.</p>
                    </>
                  )}
                <span className="kdo-partage-label">Lien de partage : </span> <span><a href={p_link} target="_blank" rel="noreferrer">{p_link}</a></span>
                <p><button onClick={copyToClipboard}>📋 Copier l'URL</button>
                {copied && <span style={{ color: "green", marginLeft: "10px" }}>Copié ! ✅</span>}</p>
                </div>
        </div>
        </div>
    ) : 
    (
        <button className="kdo-home-button" onClick={() => { 
                                                            if (window.umami) window.umami.track('share-All');
                                                            setisformPartage(true);
                                                          }}>Partager</button>
    )

};

export default Partage;